export default class UrlKeyHandler {
  private constructor(public readonly username: string, public readonly otp: string, public readonly nextUrl?: string) {}

  static fromEncodedKey(key: string): UrlKeyHandler {
    if (!key) throw new Error('Key cannot be null or undefined');

    const decoded = atob(key.toString());
    const [username, otp, nextUrl] = decoded.split(':');

    if (!username || !otp) {
      throw new Error('Invalid key format');
    }

    return new UrlKeyHandler(username, otp, nextUrl);
  }

  public getUsername(): string {
    return this.username;
  }

  public getOtp(): string {
    return this.otp;
  }

  public getEncodedOtp(): string {
    return btoa(this.otp);
  }

  public getNextUrl(): string | undefined {
    return this.nextUrl;
  }
}
